export default __webpack_public_path__ + "static/media/img7.544acaaf.png";